import { render } from "./slideVerify.vue?vue&type=template&id=395fc448&scoped=true"
import script from "./slideVerify.vue?vue&type=script&lang=js"
export * from "./slideVerify.vue?vue&type=script&lang=js"

import "./slideVerify.vue?vue&type=style&index=0&id=395fc448&scoped=true&lang=css"

import exportComponent from "/Users/user/mscode/tecs/TECS-FE-ENDUSER-NEW/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-395fc448"]])

export default __exports__